import { render, staticRenderFns } from "./remitInfo.vue?vue&type=template&id=4f2f70b1"
import script from "./remitInfo.vue?vue&type=script&lang=js"
export * from "./remitInfo.vue?vue&type=script&lang=js"
import style0 from "./remitInfo.vue?vue&type=style&index=0&id=4f2f70b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports